<script setup lang="ts">
import { Browser } from '@capacitor/browser';

import { appUrl } from '../utils/appUrl.ts';

defineProps<{ href: string }>();

function click(e: MouseEvent) {
    Browser.open({ url: (e.currentTarget as HTMLAnchorElement).href });
}
</script>

<template>
    <a :href="appUrl(href)" @click.prevent="click"><slot /></a>
</template>
